import { styled, css } from '@mui/system';
import { Container, Typography, TextField, Grid, Link, Checkbox, Button } from '@mui/material';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import DeleteIcon from '@mui/icons-material/Delete';

export const CenteredContainer = styled(Container)(
    css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #121414 1%, #1F2324 98%, #dbc363 1%)',
        color: 'white',
    })
);

export const GalleryButtonContainer = styled(Grid)({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: 0,
});

export const CenteredTypography = styled(Typography)(
    css({
        textAlign: 'center',
        color: 'white',
        fontFamily: 'DM Sans, sans-serif',
        fontSize: '14px',
    })
);

export const TitleTypography = styled(Typography)(
    css({
        textAlign: 'center',
        color: 'white',
        fontFamily: 'DM Sans, sans-serif',
        fontSize: '42px',
    })
);

export const InputStyled = styled(TextField)({
    marginBottom: 16,
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#dbc363',
    },
    '& .MuiOutlinedInput-input': {
        color: 'white',
    },
    '& .MuiInputLabel-outlined': {
        color: 'white',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ffffff',
    },
});

export const TermsAndConditionsLink = styled(Link)({
    color: 'white',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: '6px',
});

export const CheckboxContainer = styled(Grid)({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
});

export const CheckboxStyled = styled(Checkbox)({
    marginRight: '8px',
    color: '#dbc363',
});

export const CameraButtonContainer = styled(Grid)({
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    marginTop: 0,
});

export const PhotoLibraryIconStyled = styled('img')({
    width: 64,
    height: 64,
    cursor: 'pointer',
});

export const DeleteButtonStyled = styled(DeleteIcon)({
    fontSize: 20,
    cursor: 'pointer',
    color: 'white',
    position: 'absolute',
    top: '4px',
    right: '4px',
});

export const ButtonStyled = styled(Button)({
    marginTop: 16,
    '&.MuiButton-root': {
        fontSize: '1rem',
        backgroundColor: '#dbc363',
        color: 'black',
    },
    '&.Mui-disabled': {
        backgroundColor: 'gray',
    },
});

export const CarViewsImage = styled("img")({
    width: '100%',
    maxWidth: '240px',
    height: 'auto',
});
